import { Box, Typography } from '@mui/material';

interface Headingprosp {
	Title: string;
	subtitle?: string;
	style?: any;
}
export default function MyHeadings({ Title, subtitle, style }: Headingprosp) {
	return (
		<>
			<Box>
				<Typography sx={{ fontSize: { xs: 15, sm: 20, ...style }, fontWeight: 600 }}>
					{Title}
				</Typography>
				<Typography sx={{ fontSize: 10, color: '#658E81' }}>{subtitle}</Typography>
			</Box>
		</>
	);
}
